var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['half-circle-spinner loading-spinner-widget', _vm.size]},[_c('div',{staticClass:"circle circle-1"}),_c('div',{staticClass:"circle circle-2"})])}
var staticRenderFns = []

export { render, staticRenderFns }